import { useMemo } from 'react';

export interface FeatureFlags {
  enableOrders: boolean;
  enablePetszelPromotion: boolean;
  enableAccountHomePage: boolean;
  enableContractAppProcess: boolean;
}

/**
 * Hook to access feature flags in a centralized, type-safe way.
 * This provides a single source of truth for feature flag values.
 */
export const useFeatureFlags = (): FeatureFlags => {
  return useMemo(
    () => ({
      enableOrders: import.meta.env.VITE_ENABLE_ORDERS === 'true',
      enablePetszelPromotion: import.meta.env.VITE_ENABLE_PETSZEL_PROMOTION === 'true',
      enableAccountHomePage: import.meta.env.VITE_ENABLE_ACCOUNT_HOME_PAGE === 'true',
      enableContractAppProcess: import.meta.env.VITE_FSL_CONTRACT_APP_PROCESS_ENABLE === 'true',
    }),
    []
  );
};
